import {inject, Injectable} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  private translateService: TranslateService = inject(TranslateService);

  // getComplainantName(item: NewComplaint): string {
  //   if (item?.complainantType == ComplaintTypeChoiceEnum.ApplyOnBehalf)
  //     return item?.onBehalfDetails?.fullName;
  //   if (item?.complainantType == ComplaintTypeChoiceEnum.Company)
  //     return item?.submittedCompany?.companyName;
  //   if (item?.complainantType == ComplaintTypeChoiceEnum.Individual)
  //     return item?.submittedIndividual?.fullName;
  //   return null;
  // }

  translateObservable(key: string): Observable<string> {
    return this.translateService.get(key)
  }

  translate(key: string): string {
    return this.translateService.instant(key);
  }

}
